import { PageContainer } from '@you-go-vn/components';
import { Row, Tabs } from 'antd';

import { InputSearch } from '@you-go-vn/components/src/Common/Input/Input';

import TabJoined from './components/TabJoined';
import TabCanJoin from './components/TabCanJoin';
import { useState } from 'react';
import useDebounce from '@you-go-vn/components/hooks/useDebounce';
import { useLocation, useNavigate } from 'react-router-dom';

type PageProps = {
  tab: 'joined' | 'canjoin';
};
const YougoPromotionsPage = ({ tab }: PageProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [searchInput, setSearchInput] = useState('');

  const search = useDebounce((input: string) => setSearchInput(input));

  return (
    <>
      <PageContainer heading="Khuyến mãi">
        <Tabs
          destroyInactiveTabPane
          activeKey={tab}
          onChange={(activatingKey) => {
            const arrPath = location.pathname.split('/');
            if (arrPath.length > 2) arrPath.pop();
            navigate(arrPath.join('/') + '/' + activatingKey);
          }}
          tabBarExtraContent={
            <Row justify="end">
              <InputSearch
                placeholder="Tìm kiếm"
                onChange={(e) => {
                  search(e.currentTarget.value);
                }}
              />
            </Row>
          }
        >
          <Tabs.TabPane key="joined" tab="Đã tham gia">
            <TabJoined searchInput={searchInput} />
          </Tabs.TabPane>
          <Tabs.TabPane key="canjoin" tab="Có thể tham gia">
            <TabCanJoin searchInput={searchInput} />
          </Tabs.TabPane>
        </Tabs>
      </PageContainer>
    </>
  );
};

export default YougoPromotionsPage;
